
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/mapa-sjezdovek",
      function () {
        return require("private-next-pages/[region]/[resort]/mapa-sjezdovek.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/mapa-sjezdovek"])
      });
    }
  